import { createAction } from "@reduxjs/toolkit";
export const updateGrossIncome = createAction('updateGrossIncome');